import {
  useEffect,
  useRef,
  useState,
} from 'react'

import {
  Link,
} from 'react-router-dom'

interface MenuItem {
  label: string
  href: string
  external?: boolean
  react?: boolean
}

interface MenuGroup {
  label: string
  items: MenuItem[]
}

const MENU: MenuGroup[] = [
  {
    label: 'Академия',
    items: [
      {
        label: 'Главная',
        href: '/',
        react: true,
      },
      {
        label: 'Модули',
        href: '/kursy-kiberbezopasnosti/',
      },
      {
        label: 'Пути обучения',
        href: '/kursy-kiberbezopasnosti/paths/',
      },
      {
        label: 'Сертификации',
        href: '/sertifikaty-po-kiberbezopasnosti/',
      },
      {
        label: 'CTF-стенды',
        href: '/ctf-standy/',
      },
    ],
  },

  {
    label: 'Сообщество',
    items: [
      {
        label: 'Блог',
        href: 'https://krak3n.ru/',
      },
      {
        label: 'Отзывы',
        href: '/otzyvy/',
      },
    ],
  },

  {
    label: 'Помощь',
    items: [
      {
        label: 'FAQ',
        href: '/faq/',
      },
      {
        label: 'Поддержка',
        href: '/help/',
      },
    ],
  },

  {
    label: 'Мы в сети',
    items: [
      {
        label: 'О Telegram Kraken',
        href: '/telegram/',
      },
      {
        label: 'Telegram-канал',
        href: 'https://t.me/kraken_sec',
        external: true,
      },
      {
        label: 'Lolka',
        href: 'https://lolka.gg/kraken',
        external: true,
      },
      {
        label: 'Яндекс Музыка',
        href: 'https://music.yandex.ru/album/36513691',
        external: true,
      },
      {
        label: 'YouTube',
        href: 'https://www.youtube.com/@kraken_cybersecurity',
        external: true,
      },
    ],
  },
]

export function GuestHeader() {
  const [openMenu, setOpenMenu] =
    useState<string | null>(null)

  const [mobileOpen, setMobileOpen] =
    useState(false)

  const headerRef =
    useRef<HTMLElement>(null)

  useEffect(() => {
    function handlePointerDown(
      event: MouseEvent,
    ) {
      if (
        headerRef.current &&
        !headerRef.current.contains(
          event.target as Node,
        )
      ) {
        setOpenMenu(null)
        setMobileOpen(false)
      }
    }

    function handleEscape(
      event: KeyboardEvent,
    ) {
      if (event.key === 'Escape') {
        setOpenMenu(null)
        setMobileOpen(false)
      }
    }

    document.addEventListener(
      'mousedown',
      handlePointerDown,
    )

    document.addEventListener(
      'keydown',
      handleEscape,
    )

    return () => {
      document.removeEventListener(
        'mousedown',
        handlePointerDown,
      )

      document.removeEventListener(
        'keydown',
        handleEscape,
      )
    }
  }, [])

  function toggleMenu(
    label: string,
  ) {
    setOpenMenu((current) =>
      current === label
        ? null
        : label,
    )

    setMobileOpen(false)
  }

  function closeDesktopMenu() {
    setOpenMenu(null)
  }

  function closeMobileMenu() {
    setMobileOpen(false)
    setOpenMenu(null)
  }

  return (
    <header
      ref={headerRef}
      className="kr-header kr-header--guest"
    >
      <div className="kr-header__inner">
        {/* Logo */}

        <Link
          className="kr-header__brand kr-header__brand--logo"
          to="/"
          aria-label="Kraken Academy"
          onClick={() => {
            setOpenMenu(null)
            setMobileOpen(false)
          }}
        >
          <img
            className="kr-header__logo"
            src="https://jjrr9e9l0o.cdn.twcstorage.ru/headers/logo.webp"
            alt="Kraken Academy"
          />
        </Link>

        {/* Desktop navigation */}

        <nav
          className="kr-guest-nav"
          aria-label="Главное меню"
        >
          {MENU.map((group) => {
            const opened =
              openMenu === group.label

            return (
              <div
                className="kr-guest-nav__group"
                key={group.label}
              >
                <button
                  type="button"
                  className={[
                    'kr-header__nav-link',
                    opened
                      ? 'kr-header__nav-link--active'
                      : '',
                  ]
                    .filter(Boolean)
                    .join(' ')}
                  aria-expanded={opened}
                  onClick={() =>
                    toggleMenu(
                      group.label,
                    )
                  }
                >
                  {group.label}

                  <ChevronIcon />
                </button>

                {opened && (
                  <div className="kr-guest-dropdown">
                    {group.items.map(
                      (item) => {
                        if (item.react) {
                          return (
                            <Link
                              key={item.label}
                              to={item.href}
                              onClick={
                                closeDesktopMenu
                              }
                            >
                              <span>
                                {item.label}
                              </span>

                              <ArrowIcon />
                            </Link>
                          )
                        }

                        return (
                          <a
                            key={item.label}
                            href={item.href}
                            target={
                              item.external
                                ? '_blank'
                                : undefined
                            }
                            rel={
                              item.external
                                ? 'noopener noreferrer'
                                : undefined
                            }
                            onClick={
                              closeDesktopMenu
                            }
                          >
                            <span>
                              {item.label}
                            </span>

                            <ArrowIcon />
                          </a>
                        )
                      },
                    )}
                  </div>
                )}
              </div>
            )
          })}
        </nav>

        {/* Desktop auth actions */}

        <div className="kr-guest-actions">
          <Link
            to="/login/"
            className="kr-guest-login"
            onClick={() => {
              setOpenMenu(null)
              setMobileOpen(false)
            }}
          >
            Войти
          </Link>

          <Link
  to="/registration/"
  className="kr-guest-register"
  onClick={() => {
    setOpenMenu(null)
    setMobileOpen(false)
  }}
>
  Начать бесплатно
</Link>

          <button
            type="button"
            className="kr-guest-mobile-toggle"
            aria-label={
              mobileOpen
                ? 'Закрыть меню'
                : 'Открыть меню'
            }
            aria-expanded={mobileOpen}
            onClick={() => {
              setMobileOpen(
                (current) =>
                  !current,
              )

              setOpenMenu(null)
            }}
          >
            {mobileOpen ? (
              <CloseIcon />
            ) : (
              <MenuIcon />
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}

      {mobileOpen && (
        <div className="kr-guest-mobile-menu">
          <div className="kr-guest-mobile-menu__content">
            {MENU.map((group) => (
              <div
                key={group.label}
                className="kr-guest-mobile-group"
              >
                <strong>
                  {group.label}
                </strong>

                <div>
                  {group.items.map(
                    (item) => {
                      if (item.react) {
                        return (
                          <Link
                            key={
                              item.label
                            }
                            to={
                              item.href
                            }
                            onClick={
                              closeMobileMenu
                            }
                          >
                            {
                              item.label
                            }
                          </Link>
                        )
                      }

                      return (
                        <a
                          key={
                            item.label
                          }
                          href={
                            item.href
                          }
                          target={
                            item.external
                              ? '_blank'
                              : undefined
                          }
                          rel={
                            item.external
                              ? 'noopener noreferrer'
                              : undefined
                          }
                          onClick={
                            closeMobileMenu
                          }
                        >
                          {
                            item.label
                          }
                        </a>
                      )
                    },
                  )}
                </div>
              </div>
            ))}

            <div className="kr-guest-mobile-auth">
              <Link
                to="/login/"
                onClick={
                  closeMobileMenu
                }
              >
                Войти
              </Link>

              <a
                href="/registration/"
                onClick={
                  closeMobileMenu
                }
              >
                Начать бесплатно
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  )
}

function ChevronIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="m7 10 5 5 5-5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function ArrowIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M5 12h14M14 7l5 5-5 5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function MenuIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M4 7h16M4 12h16M4 17h16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

function CloseIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="m6 6 12 12M18 6 6 18"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}
